import { render, staticRenderFns } from "./createPackageOrder.vue?vue&type=template&id=5b2c3693&scoped=true"
import script from "./createPackageOrder.vue?vue&type=script&lang=js"
export * from "./createPackageOrder.vue?vue&type=script&lang=js"
import style0 from "./createPackageOrder.vue?vue&type=style&index=0&id=5b2c3693&prod&scoped=true&lang=css"
import style1 from "./createPackageOrder.vue?vue&type=style&index=1&id=5b2c3693&prod&lang=css"
import style2 from "./createPackageOrder.vue?vue&type=style&index=2&id=5b2c3693&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c3693",
  null
  
)

export default component.exports